import View from './view';

import Collection from '../collection';
import Config from '../config';
import Task from '../model/task';
import PickObjects from './pick.objects';

import { ask } from '../utils/popups';
import { hashify } from '../utils/arrays';
import { roleuc, roleaiuc } from '../roles';
import { unixts } from '../utils/date';
import { delay } from '../utils/promisify';
import { save } from '../model/task.utils';





export let TaskNew = View.extend( {

    template: 'jst/task.new',

    onBind(model) {
        this.listenTo( model, 'change:point',
            () => this.Map.render() );
    },

    serialize(context) {
        context.types = this.options.types.toJSON();
        context.organizations = this.options.organizations.toJSON();
        context.statuses = this.options.statuses.toJSON();
        context.priorities = this.options.priorities.toJSON();
        context.fields = this.options.fields.toJSON();
        context.contracts = this.options.contracts.toJSON();
        context.serviceObjectMappings = this.options.serviceObjectMappings;

        context.locationService = this.options.locationService;

        return context;
    },

    events: {

        'click .-choose-object'() {
            const contractId = this.model.get( 'contract_id' );
            const contract = contractId && this.options.contracts
                .find( contract => contract.id == contractId );

            const hasContractObjects = !contract
                ? false
                : contract.get( 'groups' ).length &&
                  contract.get( 'groups' )
                    .every( ({ objects }) => objects.length );

            const objects = !hasContractObjects
                ? undefined
                : this.options.contracts.find( contract => contract.id == contractId )
                    .get( 'groups' )
                    .filter( ({ types }) => +this.model.get( 'type_id' ) > 0 && types.length
                        ? types.some( type => type.id == this.model.get( 'type_id' ) )
                        : true )
                    .map( group => group.objects )
                    .reduce( (result, objects) => [...result, ...objects], [] );

            const layerIds = !hasContractObjects
                ? undefined
                : hashify( this.options.contracts.find( contract => contract.id == contractId )
                    .get( 'groups' )
                    .map( group => group.objects )
                    .reduce( (result, objects) => [...result, ...objects], [] )
                    .map( group => group.layer_id ) );

            const view = PickObjects.of( {
                datatables: new Collection( this.options.layers
                    .toJSON()
                    .filter( layer => !hasContractObjects || layerIds[layer.id] )
                    .filter( layer => layer.access.serviceObjects ) ),
                objects,
                multiple: false 
            } );

            return ask( view.render(), 'service.object::choose',
                'actions::choose', 'actions::cancel',
                { large: true },
                () => view.chosen_ && this.model.set( {
                    service_object_id: view.chosen_.id,
                    service_object_layer_id: view.chosen_.get( 'layer_id' ),
                    service_object_title: view.chosen_.get( 'name' )
                } ) );
        },

        'click .-remove-object'() {
            this.model.set( {
                service_object_layer_id: undefined,
                service_object_id: undefined,
                service_object_title: undefined,
                sys_org_id: undefined,
                sys_clr_id: undefined
        } );
        },

    },

    [View.event( 'Map:service-object:choose' )]({ objectId, layerId, title }) {
        if (this.model)
            this.model.set( {
                service_object_title: title.replace( /\<\/?span[^\>]*>/g, '' ).trim(),
                service_object_id: objectId,
                service_object_layer_id: layerId
            } );
    },

    [View.event( 'Map:map:click' )](location) {
        if (this.model)
            this.model.set( 'location', location );
    },

    [View.event( 'Map:address:choose' )]({ coords }) {
        if (this.model)
            this.model.set( 'location', coords );
    }

} );

export function newTask(taskNew, priorities) {
    const priorityClusters = hashify( priorities.toJSON()
        .map( priority => priority.cluster )
        .filter( cluster => cluster )
        .map( cluster => cluster.id ) );
    const [priority] = Object.keys( priorityClusters ).length === 1
        ? priorities.models
        : [];
    const organizationId = roleaiuc.includes( Config.role() )
        && Config.orgs().length == 1
        && Config.orgs()[0];

    const task = new Task( { 
        date: unixts( new Date() ),
        priority_id: priority && priority.id,
        organization_id: organizationId,
    } );

    task.capabilities_ = {
        edit: true,
        update_title: true, update_text: true,
        update_type: true, update_priority: true, update_point: true,
        update_deadline: true,
        update_custom_fields: true,
        assign_department: !roleuc.includes( Config.role() ),
        assign_user: !roleuc.includes( Config.role() ),
    };

    return ask( bindTaskWindow( taskNew, task ),
        'issue::modal new - title',
        'actions::create', 'actions::cancel',
        (form, _, modal) => {
            form.enable(), modal.enable();

            const { result, messages } = taskNew.TaskForm.validate();
            if (!result)
                return Promise.reject( messages[0] /* [text, field] */ );
        
            return form.disable(), modal.disable(), save( taskNew );
        } );
}

function bindTaskWindow(taskNew, task) {
    // hack begins
    taskNew.$el.css( { opacity:0, transform:'scale(0.01)' } ).appendTo( document.body );

    // render view
    const binding = (task ? taskNew.bind( task ) : taskNew.render())
        // hack continues
        .then( () => delay( 350 ) )
        // don't remove, just detach to avoid dropping event handlers
        .then( () => taskNew.$el.detach().css( { opacity:1, transform:'scale(1)' } ) )
        // hack ends
        .then( () => taskNew );

    return binding.view = taskNew, binding;
}




// WEBPACK FOOTER //
// ./src/js/view/task.new.js